import { router, SpaForceConfigurationReloadEventKey } from '@/core/router';
import { QueryKeys } from '@/shared/config/route-query.config';
import { computed } from 'vue';
import { applyFacets } from '@/core/browser/route-query.composable';
import bus from '@/core/bus';

export default function useProductDetailPage() {
    const skuFromUrl = computed<string>(() => {
        const path = router.currentRoute.value.path;
        const regex = new RegExp('([^/]+)/?$');
        const skuMatchGroup = path.match(regex);
        const skuMatch = skuMatchGroup ? skuMatchGroup[1] : '';
        return skuMatch;
    });

    const getNewPathFromSku = (sku: string) :string => {
        const path = router.currentRoute.value.path;
        const urlSku = skuFromUrl.value;
        return path.replace(urlSku, sku);
    };
    const updateRouter = async(sku: string, silent?: number) => {
        const newPath = getNewPathFromSku(sku);
        const currentQuery = router.currentRoute.value.query;
        return await router.replace({
            path: newPath,
            query: {
                ...currentQuery,
                [QueryKeys.SpaSilentUpdate]: silent,
            },
        });
    };
    const updateSku = async(sku: string) => {
        await updateRouter(sku, 1);
        await updateRouter(sku);
    };

    const updateConfiguration = async(sku: string, id: string, edit?: string) => {
        await applyFacets(router, router.currentRoute.value, { [QueryKeys.PDPConfigurationId]: id, [QueryKeys.SpaSilentUpdate]: '1', [QueryKeys.Edit]: edit });
        if (sku !== skuFromUrl.value) {
            await updateSku(sku);
        } else {
            bus.emit(SpaForceConfigurationReloadEventKey);
        }
    };

    return {
        skuFromUrl,
        getNewPathFromSku,
        updateSku,
        updateConfiguration,
    };
}
